<template>
  <div>
    <CRow class="d-flex justify-content-start align-items-center px-3">
      <p>
        {{ $t("models.role.userSettings.transparency.subtitle") }}
      </p>
    </CRow>

    <CCard class="border-0">
      <CCardHeader class="">
        <div class="card-title">
          {{ $t("models.role.userSettings.transparency.eco.title") }}
        </div>
      </CCardHeader>

      <CCardBody>
        <!-- extra.transparency.biodiversity -->
        <CRow>
          <CCol md="12">
            <CTextarea
              :placeholder="
                $t('models.role.userSettings.transparency.eco.placeholder')
              "
              :label="$t('models.role.userSettings.transparency.eco.label')"
              v-model="profileData.extra.transparency.biodiversity"
              rows="9"
            />
          </CCol>
        </CRow>

        <!-- extra.transparency.soil -->
        <CRow>
          <CCol md="12">
            <CTextarea
              :placeholder="
                $t('models.role.userSettings.transparency.eco.soil.placeholder')
              "
              :label="
                $t('models.role.userSettings.transparency.eco.soil.label')
              "
              v-model="profileData.extra.transparency.soil"
              rows="9"
            />
          </CCol>
        </CRow>

        <!-- extra.transparency.animals -->
        <CRow>
          <CCol md="12">
            <CTextarea
              :placeholder="
                $t(
                  'models.role.userSettings.transparency.eco.animals.placeholder'
                )
              "
              :label="
                $t('models.role.userSettings.transparency.eco.animals.label')
              "
              v-model="profileData.extra.transparency.animals"
              rows="9"
            />
          </CCol>
        </CRow>

        <!-- extra.transparency.climate -->
        <CRow>
          <CCol md="12">
            <CTextarea
              :placeholder="
                $t(
                  'models.role.userSettings.transparency.eco.climate.placeholder'
                )
              "
              :label="
                $t('models.role.userSettings.transparency.eco.climate.label')
              "
              v-model="profileData.extra.transparency.climate"
              rows="9"
            />
          </CCol>
        </CRow>

        <!-- extra.transparency.cycles -->
        <CRow>
          <CCol md="12">
            <CTextarea
              :placeholder="
                $t(
                  'models.role.userSettings.transparency.eco.cycles.placeholder'
                )
              "
              :label="
                $t('models.role.userSettings.transparency.eco.cycles.label')
              "
              v-model="profileData.extra.transparency.cycles"
              rows="9"
            />
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard class="border-0">
      <CCardHeader class="">
        <div class="card-title">
          {{ $t("models.role.userSettings.transparency.social.title") }}
        </div>
      </CCardHeader>

      <CCardBody>
        <!-- extra.transparency.diversification -->
        <CRow>
          <CCol md="12">
            <CTextarea
              :placeholder="
                $t(
                  'models.role.userSettings.transparency.social.diversification.placeholder'
                )
              "
              :label="
                $t(
                  'models.role.userSettings.transparency.social.diversification.label'
                )
              "
              v-model="profileData.extra.transparency.diversification"
              rows="9"
            />
          </CCol>
        </CRow>

        <!-- extra.transparency.type -->
        <CRow>
          <CCol md="12">
            <CTextarea
              :placeholder="
                $t(
                  'models.role.userSettings.transparency.social.type.placeholder'
                )
              "
              :label="
                $t('models.role.userSettings.transparency.social.type.label')
              "
              v-model="profileData.extra.transparency.type"
              rows="9"
            />
          </CCol>
        </CRow>

        <!-- extra.transparency.team -->
        <CRow>
          <CCol md="12">
            <CTextarea
              :placeholder="
                $t(
                  'models.role.userSettings.transparency.social.team.placeholder'
                )
              "
              :label="
                $t('models.role.userSettings.transparency.social.team.label')
              "
              v-model="profileData.extra.transparency.team"
              rows="9"
            />
          </CCol>
        </CRow>

        <vue-ladda
          :loading="saving"
          data-style="zoom-in"
          button-class="btn btn-primary mt-3"
          @click="onSave"
        >
          {{ $t("common.editor.button.save") }}
        </vue-ladda>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { apiPatch } from "../../../helpers/apiHelper";

export default {
  props: {
    profileData: Object,
  },

  name: "ProfileTransparency",

  data() {
    return {
      saving: false,
    };
  },

  methods: {
    async onSave() {
      this.saving = true;
      const roleId = this.$store.state.role.id;
      const requestParams = {
        id: roleId,
        extra: this.profileData.extra,
      };

      const response = await apiPatch("auth_frole", roleId, requestParams);
      if (response && response.status === 200) {
        this.saving = false;
        this.$store.dispatch("toaster/add", {
          title: "OK!",
          text: this.$t("role.finance.invoicesSettings.success"),
          color: "success",
          autohide: true,
        });
      } else {
        console.error("Unexpected response:", response);
        this.saving = false;
        Object.entries(response).forEach(([key, value]) => {
          this.$store.dispatch("toaster/add", {
            title: this.$t("common.general.savingError"),
            text: `${key}: ${value}`,
            color: "danger",
            autohide: true,
          });
        });
      }
    },
  },
};
</script>
